import React, { useEffect } from "react";
import NavigationBar from "../../../components/NavigationBar/NavigationBar";
import HomeContent from "../../../components/HomeContent/HomeContent";
import Footer from "../../../components/Footer/Footer";
import { Images } from "@workspace/common";
import "../JobPortal.scss";

export default function JobPortalHome() {
  useEffect(() => {
    document.title =
      "Best IT Recruitment Agency in Singapore | Avensys Consulting";
    changeFavicon(Images.favicon_jp);
  }, []);

  const changeFavicon = (faviconURL) => {
    const link =
      document.querySelector("link[rel*='icon']") ||
      document.createElement("link");
    link.type = "image/x-icon";
    link.rel = "shortcut icon";
    link.href = faviconURL;
    document.getElementsByTagName("head")[0].appendChild(link);
  };

  return (
    <div style={{ minWidth: "550px" }}>
      <NavigationBar />
      <HomeContent />
      <Footer cssClass={"fixed-bottom"} />
    </div>
  );
}
